import { Alert, Col, Typography } from 'antd'
import { useScanBlockchain, useSupportedBlockchains } from 'api'
import Container from 'components/Container'
import { useHideModal } from 'components/Modals'
import { Formik } from 'formik'
import { useLocalization } from 'localization'
import appRoutes from 'modules/common/app-routes'
import { useRouter } from 'next/router'
import { createValidationSchema } from 'utils/validation'
import ScanBlockchainForm, { IFormValues } from './form'
import { useTheme } from 'styled-components'

import Styled from './styled'
import { useState } from 'react'

const schema = createValidationSchema(yup =>
	yup.object({
		walletAddress: yup.string().required(),
	})
)

const ScanTab = () => {
	const theme = useTheme()
	const { t } = useLocalization()
	const hideModal = useHideModal()
	const { mutateAsync: scanBlockchain } = useScanBlockchain()
	const { data: blockchains = [], isLoading } = useSupportedBlockchains()
	const [expanded, setExpanded] = useState(false)
	const router = useRouter()

	const onSubmit = async (values: IFormValues) => {
		await scanBlockchain({
			walletAddress: values.walletAddress,
		})
		hideModal()
		router.push(appRoutes.integrations.list())
	}

	const initialValue: IFormValues = {
		walletAddress: '',
	}

	if (isLoading) return null

	return (
		<Container display="flex" flexDirection="column" space="md" spaceDirection="vertical">
			<Typography.Title level={5}>{t('integrations.scan.title')}</Typography.Title>
			<Typography.Text>{t('integrations.scan.description')}</Typography.Text>
			<Styled.ExpandableContainer gutter={[theme.paddings.xs, theme.paddings.xs]} $collapsed={!expanded}>
				{blockchains.map(name => (
					<Col key={name} xs={6}>
						<Styled.BlockchainNameItem>{name}</Styled.BlockchainNameItem>
					</Col>
				))}
				{!expanded && (
					<Styled.ExpandButtonContainer>
						<Typography.Link href="#" onClick={() => setExpanded(true)}>
							{t('actions.showAll')}
						</Typography.Link>
					</Styled.ExpandButtonContainer>
				)}
			</Styled.ExpandableContainer>
			{expanded && (
				<Container display="flex" justifyContent="center">
					<Typography.Link href="#" onClick={() => setExpanded(false)}>
						{t('actions.collapse')}
					</Typography.Link>
				</Container>
			)}
			<Typography.Text>{t('integrations.scan.subDescription')}.</Typography.Text>
			<Alert message={t('integrations.scan.warning')} type="info" />
			<Formik initialValues={initialValue} validationSchema={schema} enableReinitialize onSubmit={onSubmit}>
				<ScanBlockchainForm />
			</Formik>
		</Container>
	)
}

export default ScanTab
